// This in in use
import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  TextField,
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Autocomplete,
  Tooltip,
  IconButton,
  CircularProgress,
} from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { BASE_URL } from "../../constants";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import InfoIcon from "@mui/icons-material/Info";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";

// Shared field style
const fieldStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    background: "#ffffff",
    fontSize: "0.875rem",
    "& fieldset": { borderColor: "#e5e9ef" },
    "&:hover fieldset": { borderColor: "#2a54a6" },
    "&.Mui-focused fieldset": {
      borderColor: "#b93acf",
      borderWidth: "1.5px",
    },
  },
};

// Shared label style
const labelStyle = {
  fontSize: "0.72rem",
  fontWeight: 600,
  color: "#0a1f44",
  letterSpacing: "0.2px",
  mb: 0.6,
};

// Required asterisk
const Req = () => (
  <Box component="span" sx={{ color: "#b93acf", ml: "2px", fontWeight: 700 }}>
    *
  </Box>
);

const INITIAL_STATE = {
  name: "",
  dob: "",
  age: "",
  gender: "",
  mobile: "",
  address: "",
  aadhar: "",
};
const PatientRegForm = ({
  patientRef,
  open,
  setRegistered,
  setRegisteredPatientData,
}) => {
  console.log("REFFF", patientRef);
  const [patientData, setPatientData] = useState(INITIAL_STATE);
  const user = useRecoilValue(authState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPatientData({
      name: patientRef?.patientName,
      dob: "",
      age: patientRef?.patientAge,
      gender: patientRef?.patientSex,
      mobile: patientRef?.patientPhone,
      address: "",
      aadhar: "",
    });
  }, [patientRef]);

  const handleChange = (e) => {
    if (e.target.name === "age") {
      if (patientData.dob === "") {
        return setPatientData({
          ...patientData,
          [e.target.name]: e.target.value,
        });
      } else {
        return setPatientData({ ...patientData, age: e.target.value, dob: "" });
      }
    }
    setPatientData({
      ...patientData,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (newValue) => {
    const formattedDate = dayjs(newValue).format("DD-MM-YY"); // Display in "DD-MM-YY" format
    if (patientData.age === "") {
      return setPatientData({ ...patientData, dob: formattedDate });
    } else {
      return setPatientData({ ...patientData, dob: formattedDate, age: "" });
    }
  };

  const calculateAge = (dob) => {
    //if (!dob) return "Enter a valid DOB";
    const birthDate = dayjs(dob, "DD-MM-YY");
    //if (!birthDate.isValid()) return "Invalid DOB format";
    const now = dayjs();
    const years = now.diff(birthDate, "year");
    const months = now.diff(birthDate.add(years, "year"), "month");
    const days = now.diff(
      birthDate.add(years, "year").add(months, "month"),
      "day",
    );
    return `${years}Y ${months}M ${days}D`;
  };

  const handleGenderChange = (e) => {
    const { value } = e.target;
    setPatientData({ ...patientData, gender: value });
  };
  const validateForm = () => {
    const newErrors = {};

    if (!patientData.name) {
      newErrors.name = "Patient name is required.";
    }
    if (!patientData.dob && !patientData.age) {
      newErrors.dob = "required.";
      newErrors.age = "required.";
    }
    if (!patientData.gender) {
      newErrors.gender = "Patient gender is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      let data = patientData;

      if (patientData.dob) {
        const formattedDob = dayjs(patientData.dob, "DD-MM-YY").format(
          "MMMM DD, YYYY",
        );
        data = { ...data, dob: formattedDob };
      }

      if (parseInt(patientData.age) > 0) {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth();
        const currentdate = new Date().getDate();
        const yearOfBirth = currentYear - parseInt(patientData.age);
        const dob = new Date(yearOfBirth, currentMonth, currentdate);
        const formattedDob = `${dob.toLocaleString("en-US", {
          month: "long",
        })} ${dob.getDate().toString().padStart(2, "0")}, ${dob.getFullYear()}`;

        data = {
          ...data,
          dob: formattedDob,
          patientRefId: patientRef?._id || null,
        };
      }
      delete data.age;

      try {
        setLoadingSubmit(true);

        const response = await fetch(
          `${BASE_URL}api/user/common/patient-register`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          },
        );

        const resp = await response.json();

        if (resp.success) {
          console.log("Registration successful", resp);
          alert(resp.message);
          setPatientData(INITIAL_STATE);
          // setRegistered(true);
          // setRegisteredPatientData(resp.patient);
        } else {
          console.log("Error:", resp.message);
          alert("Error: " + resp.message);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setLoadingSubmit(false);
      }
    }
  };

  return (
    <>
      {user?._doc?.permissions?.patientManagement?.create && (
        <Accordion
          defaultExpanded={open}
          sx={{
            borderRadius: "14px !important",
            background: "#ffffff",
            border: "1px solid #e5e9ef",
            boxShadow: "0 2px 12px rgba(10,31,68,0.06)",
            "&:before": { display: "none" },
            "&.Mui-expanded": {
              margin: "0",
              boxShadow: "0 8px 28px rgba(10,31,68,0.1)",
            },
            overflow: "hidden",
          }}
        >
          <AccordionSummary
            expandIcon={
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "8px",
                  background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                  border: "1px solid rgba(185,58,207,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ExpandMoreIcon sx={{ color: "#fff", fontSize: "1.1rem" }} />
              </Box>
            }
            sx={{
              background: "#ffffff",
              borderBottom: "1px solid #e5e9ef",
              px: 2.5,
              py: 1,
              minHeight: "56px !important",
              "&.Mui-expanded": { minHeight: "56px !important" },
              "& .MuiAccordionSummary-content": { margin: "12px 0 !important" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "9px",
                  background: "linear-gradient(135deg, #0f6e56, #1d9e75)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
                }}
              >
                <PersonAddIcon sx={{ color: "#ffffff", fontSize: "1rem" }} />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontSize: "0.95rem",
                    fontWeight: 700,
                    color: "#064e3b",
                    letterSpacing: "-0.2px",
                    lineHeight: 1.2,
                  }}
                >
                  Register Patient
                </Typography>
                <Typography
                  sx={{ fontSize: "0.68rem", color: "#94a3b8", mt: "1px" }}
                >
                  Fill in the details below to register a new patient
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>

          <AccordionDetails sx={{ background: "#f8fafc", p: 2.5 }}>
            <Box component="form">
              <Grid container spacing={2}>
                {/* Name */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Full Name <Req />
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter patient name"
                    variant="outlined"
                    name="name"
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    value={patientData.name}
                    size="small"
                    sx={fieldStyle}
                  />
                </Grid>

                {/* DOB + Age */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Date of Birth / Age <Req />
                  </Typography>
                  <Box
                    sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}
                  >
                    <FormControl fullWidth error={!!errors.dob}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        {patientData?.dob && (
                          <Tooltip
                            title={
                              <Typography variant="body2" color="inherit">
                                {calculateAge(patientData.dob)}
                              </Typography>
                            }
                            open
                            placement="top"
                            arrow
                          />
                        )}
                        <DatePicker
                          label=""
                          onChange={handleDateChange}
                          format="DD-MM-YY"
                          maxDate={dayjs()}
                          value={
                            patientData.dob
                              ? dayjs(patientData.dob, "DD-MM-YY")
                              : null
                          }
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              size: "small",
                              placeholder: "DD-MM-YY",
                              error: !!errors.dob,
                              sx: fieldStyle,
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </FormControl>

                    <Box
                      sx={{
                        flexShrink: 0,
                        height: 40,
                        display: "flex",
                        alignItems: "center",
                        px: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          fontWeight: 700,
                          color: "#94a3b8",
                          letterSpacing: "0.5px",
                        }}
                      >
                        OR
                      </Typography>
                    </Box>

                    <TextField
                      placeholder="Age"
                      variant="outlined"
                      name="age"
                      onChange={handleChange}
                      value={patientData.age}
                      size="small"
                      sx={{ ...fieldStyle, width: "90px", flexShrink: 0 }}
                    />
                  </Box>
                </Grid>

                {/* Gender */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Gender <Req />
                  </Typography>
                  <FormControl fullWidth error={!!errors.gender} size="small">
                    <Select
                      value={patientData.gender || ""}
                      onChange={handleGenderChange}
                      name="gender"
                      displayEmpty
                      sx={{
                        borderRadius: "10px",
                        background: "#ffffff",
                        fontSize: "0.875rem",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e5e9ef",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#2a54a6",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#b93acf",
                          borderWidth: "1.5px",
                        },
                      }}
                    >
                      <MenuItem
                        value=""
                        disabled
                        sx={{ fontSize: "0.875rem", color: "#94a3b8" }}
                      >
                        Select gender
                      </MenuItem>
                      <MenuItem value="Male" sx={{ fontSize: "0.875rem" }}>
                        Male
                      </MenuItem>
                      <MenuItem value="Female" sx={{ fontSize: "0.875rem" }}>
                        Female
                      </MenuItem>
                      <MenuItem value="Others" sx={{ fontSize: "0.875rem" }}>
                        Others
                      </MenuItem>
                    </Select>
                    {errors.gender && (
                      <FormHelperText sx={{ fontSize: "0.72rem" }}>
                        {errors.gender}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Mobile */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Mobile
                    <span
                      style={{
                        color: "#94a3b8",
                        fontWeight: 400,
                        marginLeft: 4,
                      }}
                    >
                      (optional)
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="+91 00000 00000"
                    variant="outlined"
                    type="tel"
                    name="mobile"
                    onChange={handleChange}
                    error={!!errors.mobile}
                    helperText={errors.mobile}
                    value={patientData.mobile}
                    size="small"
                    sx={fieldStyle}
                  />
                </Grid>

                {/* Address */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Address
                    <span
                      style={{
                        color: "#94a3b8",
                        fontWeight: 400,
                        marginLeft: 4,
                      }}
                    >
                      (optional)
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Street, City"
                    variant="outlined"
                    name="address"
                    onChange={handleChange}
                    error={!!errors.address}
                    helperText={errors.address}
                    value={patientData.address}
                    size="small"
                    sx={fieldStyle}
                  />
                </Grid>

                {/* Aadhar */}
                <Grid item xs={12} sm={4}>
                  <Typography sx={labelStyle}>
                    Aadhar
                    <span
                      style={{
                        color: "#94a3b8",
                        fontWeight: 400,
                        marginLeft: 4,
                      }}
                    >
                      (optional)
                    </span>
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="XXXX XXXX XXXX"
                    variant="outlined"
                    name="aadhar"
                    onChange={handleChange}
                    error={!!errors.aadhar}
                    helperText={errors.aadhar}
                    value={patientData.aadhar}
                    size="small"
                    sx={fieldStyle}
                  />
                </Grid>

                {/* Submit */}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      pt: 0.5,
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={handleSubmit}
                      disabled={loadingSubmit}
                      startIcon={
                        loadingSubmit ? null : (
                          <PersonAddIcon sx={{ fontSize: "1rem !important" }} />
                        )
                      }
                      sx={{
                        background: loadingSubmit
                          ? "#e5e9ef"
                          : "linear-gradient(135deg, #0f6e56, #1d9e75)",
                        color: loadingSubmit ? "#94a3b8" : "#ffffff",
                        fontWeight: 700,
                        fontSize: "0.82rem",
                        textTransform: "none",
                        letterSpacing: "0.2px",
                        borderRadius: "10px",
                        px: 3,
                        py: 1,
                        boxShadow: loadingSubmit
                          ? "none"
                          : "0 4px 14px rgba(16,185,129,0.3)",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #064e3b, #0f6e56)",
                          boxShadow: "0 6px 20px rgba(16,185,129,0.4)",
                        },
                        "&:disabled": { background: "#e5e9ef" },
                        transition: "all 0.25s ease",
                      }}
                    >
                      {loadingSubmit ? "Submitting…" : "Register Patient"}
                    </Button>
                    {loadingSubmit && (
                      <CircularProgress size={18} sx={{ color: "#10b981" }} />
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
    </>
  );
};

export default PatientRegForm;
